var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	21576: () => (loadStrictSingletonVersion("default", "@angular/core", true, [1,19,2,14], () => (() => (__webpack_require__(/*! @angular/core */ 37580))))),
	53518: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", true, [1,19,2,14], () => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))),
	80850: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", true, [1,19,2,14], () => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))))),
	53169: () => (loadStrictSingletonVersion("default", "rxjs", true, [2,7,8,0], () => (() => (__webpack_require__(/*! rxjs */ 80845))))),
	953: () => (loadStrictSingletonVersion("default", "rxjs/operators", true, [2,7,8,0], () => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))),
	29010: () => (loadStrictSingletonVersion("default", "@angular/common", true, [1,19,2,14], () => (() => (__webpack_require__(/*! @angular/common */ 60316))))),
	94067: () => (loadStrictSingletonVersion("default", "@angular/cdk/a11y", true, [1,19,2,19], () => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))))),
	23151: () => (loadStrictSingletonVersion("default", "@angular/cdk/keycodes", true, [1,19,2,19], () => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 74879))))),
	42379: () => (loadStrictSingletonVersion("default", "@angular/cdk/platform", true, [1,19,2,19], () => (() => (__webpack_require__(/*! @angular/cdk/platform */ 17699))))),
	65771: () => (loadStrictSingletonVersion("default", "@angular/cdk/coercion", true, [1,19,2,19], () => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))),
	75433: () => (loadStrictSingletonVersion("default", "@angular/cdk/private", true, [1,19,2,19], () => (() => (__webpack_require__(/*! @angular/cdk/private */ 9227))))),
	22869: () => (loadStrictSingletonVersion("default", "@angular/cdk/scrolling", true, [1,19,2,19], () => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 79975))))),
	59191: () => (loadStrictSingletonVersion("default", "@angular/cdk/overlay", true, [1,19,2,19], () => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))),
	88883: () => (loadStrictSingletonVersion("default", "@angular/cdk/bidi", true, [1,19,2,19], () => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 63680))))),
	51995: () => (loadStrictSingletonVersion("default", "@angular/cdk/layout", true, [1,19,2,19], () => (() => (__webpack_require__(/*! @angular/cdk/layout */ 87912))))),
	13439: () => (loadStrictSingletonVersion("default", "@angular/cdk/portal", true, [1,19,2,19], () => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))),
	43460: () => (loadStrictSingletonVersion("default", "@angular/forms", true, [1,19,2,14], () => (() => (__webpack_require__(/*! @angular/forms */ 34456))))),
	26417: () => (loadStrictSingletonVersion("default", "@angular/cdk/observers/private", true, [1,19,2,19], () => (() => (__webpack_require__(/*! @angular/cdk/observers/private */ 98615))))),
	43939: () => (loadStrictSingletonVersion("default", "@angular/cdk/dialog", true, [1,19,2,19], () => (() => (__webpack_require__(/*! @angular/cdk/dialog */ 93482))))),
	32561: () => (loadStrictSingletonVersion("default", "@angular/cdk/collections", true, [1,19,2,19], () => (() => (__webpack_require__(/*! @angular/cdk/collections */ 37989))))),
	14718: () => (loadStrictSingletonVersion("default", "@angular/animations/browser", true, [1,19,2,14], () => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))),
	56806: () => (loadStrictSingletonVersion("default", "@angular/common/http", true, [1,19,2,14], () => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))),
	26665: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", true, [1,19,2,14], () => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))),
	46927: () => (loadStrictSingletonVersion("default", "@ng-idle/core", true, [1,12,0,4], () => (() => (__webpack_require__(/*! @ng-idle/core */ 28177))))),
	57593: () => (loadStrictSingletonVersion("default", "@ngrx/store", true, [1,17,2,0], () => (() => (__webpack_require__(/*! @ngrx/store */ 81383))))),
	87512: () => (loadStrictSingletonVersion("default", "@angular/core/rxjs-interop", true, [1,19,2,14], () => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074)))))
};
var initialConsumes = [21576,53518,80850,53169,953,29010,94067,23151,42379,65771,75433,22869,59191,88883,51995,13439,43460,26417,43939,32561,14718,56806,26665,46927,57593,87512];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
// no chunk loading of consumes